import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f9f74b16")

_pushScopeId("data-v-f9f74b16")
const _hoisted_1 = { class: "Auth" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_login_form = _resolveComponent("login-form")!
  const _component_restore_form = _resolveComponent("restore-form")!
  const _component_confirmation_form = _resolveComponent("confirmation-form")!
  const _component_auth_form_wrapper = _resolveComponent("auth-form-wrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_auth_form_wrapper, null, {
      default: _withId(() => [
        (_ctx.authState.isLoginForm)
          ? (_openBlock(), _createBlock(_component_login_form, {
              key: 0,
              onRestore: _ctx.setRestoreForm,
              onSignin: _ctx.loginFormState.asyncFetch,
              loading: _ctx.loginFormState.state.is_loading
            }, null, 8, ["onRestore", "onSignin", "loading"]))
          : (_ctx.authState.isRestoreForm)
            ? (_openBlock(), _createBlock(_component_restore_form, {
                key: 1,
                onBack: _ctx.setLoginForm,
                onSendCode: _ctx.recoveryFormState.asyncFetch,
                loading: _ctx.recoveryFormState.state.is_loading
              }, null, 8, ["onBack", "onSendCode", "loading"]))
            : (_ctx.authState.isConfirmationForm)
              ? (_openBlock(), _createBlock(_component_confirmation_form, {
                  key: 2,
                  onConfirm: _ctx.confirmFormState.asyncFetch,
                  onBack: _ctx.setRestoreForm,
                  loading: _ctx.confirmFormState.state.is_loading
                }, null, 8, ["onConfirm", "onBack", "loading"]))
              : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})